import React, { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import commonService from '../../services/commonService';

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
	const [sidebarLogoUrl, setSidebarLogoUrl] = useState<string | null>(null);

	useEffect(() => {
		let active = true;
		commonService
			.getAppAssetUrl('splashlogo')
			.then((url) => {
				if (active) setSidebarLogoUrl(url);
			})
			.catch(() => undefined);
		return () => {
			active = false;
		};
	}, []);

	return (
		<div className='brand'>
			<div className='brand-logo'>
				<h1 className='brand-title '>
					<Link to='/' aria-label='Logo'>
						{sidebarLogoUrl && (
							<img
								src={sidebarLogoUrl}
								alt='Logo'
								style={{ height: '48px', maxWidth: '160px', objectFit: 'contain' }}
							/>
						)}
					</Link>
				</h1>
			</div>
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				onClick={() => setAsideStatus(!asideStatus)}>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
